import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import featureFlags from 'shared/lib/featureFlags';
import { DEFAULT_LANGUAGE_CODE, I18N_LANGUAGES, LANGUAGE } from 'shared/constants';

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(intervalPlural)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      // loadPath: '/locales/{{lng}}/{{ns}}.json'
      loadPath: `/locales/{{lng}}/{{ns}}.json?${import.meta.env.REACT_APP_RELEASE_VERSION || 'default'}`
    },
    initImmediate: true,
    preload: [LANGUAGE.CS, LANGUAGE.EN],
    defaultNS: 'common',
    ns: ['common', 'userportal', 'backoffice', 'admin'],
    supportedLngs: I18N_LANGUAGES,
    fallbackLng: DEFAULT_LANGUAGE_CODE,
    // lng: 'cs',
    debug: process.env.NODE_ENV !== 'production',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true
    }
  });

if (featureFlags.i18n) {
  i18n.t = (...args) => args[0];
}

export default i18n;
